import { Col, Form, Input, Text } from 'components/common'

interface reasonProps {
  name?: string
  reason?: string
}

export const DiscountReason = ({ name, reason }: reasonProps) => (
  <>
    <Col span={24}>
      <Form.Item
        name={name}
        label="理由"
        rules={[
          {
            required: true,
          },
          {
            validator: (_, value) => {
              if (value.length > 0 && value.length <= 120) {
                return Promise.resolve()
              }
              return Promise.reject(new Error('理由は最大120文字までです。'))
            },
          },
        ]}
        initialValue={reason ? reason : ''}
        extra={<Text type="secondary">お客様にはこの理由が表示されます。</Text>}
      >
        <Input autoComplete="off" />
      </Form.Item>
    </Col>
  </>
)

export const ExtensionFeeReason = ({ name, reason }: reasonProps) => (
  <>
    <Col span={24}>
      <Form.Item
        name={name}
        rules={[
          {
            required: true,
            message: '理由は必須です。',
          },
          {
            validator: (_, value) => {
              if (value.length <= 120) {
                return Promise.resolve()
              }
              return Promise.reject(new Error('理由は最大120文字までです。'))
            },
          },
        ]}
        initialValue={reason ? reason : ''}
      >
        <Input
          autoComplete="off"
          placeholder="お客様にはこの理由が表示されます。"
        />
      </Form.Item>
    </Col>
  </>
)
